import React from 'react';

export const CardPartnerAlt = ({ title, image, link, classes = '' }) => {
  const Tag = link ? 'a' : 'div';
  const attributes = link
    ? { href: link, target: '_blank', rel: 'noopener' }
    : {};

  return (
    <Tag
      {...attributes}
      className={`zg-card-logo p-3 border rounded-4 d-block ${classes}`}
    >
      <img
        className="mb-4 mt-2 me-2 ms-auto d-block"
        src={image || '/rsk-icon.png'}
        alt={title}
        width="123"
        height="52"
      />
      <h3 className="h6 mb-0 fw-normal letter-spacing-1">{title}</h3>
    </Tag>
  );
};
